import { render, staticRenderFns } from "./VariantSifterRegionLoadBubble.vue?vue&type=template&id=2241d03e&scoped=true&"
import script from "./VariantSifterRegionLoadBubble.vue?vue&type=script&lang=js&"
export * from "./VariantSifterRegionLoadBubble.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterRegionLoadBubble.vue?vue&type=style&index=0&id=2241d03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241d03e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2241d03e')) {
      api.createRecord('2241d03e', component.options)
    } else {
      api.reload('2241d03e', component.options)
    }
    module.hot.accept("./VariantSifterRegionLoadBubble.vue?vue&type=template&id=2241d03e&scoped=true&", function () {
      api.rerender('2241d03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterRegionLoadBubble.vue"
export default component.exports